import type { ICamera } from "@/data/interfaces/camera";

export const ALTA_CAMERA_SNOOZE_DISABLED_MESSAGE = "Alta Cameras cannot be Snoozed at this time";

type CameraIntegrationFields = Pick<ICamera, "general_description" | "location_description">;

export function isAvigilonAltaCamera(camera: Partial<CameraIntegrationFields> | null | undefined): boolean {
  return [camera?.general_description, camera?.location_description].some(
    value =>
      typeof value === "string" &&
      value
        .replace(/[^a-z0-9]/gi, "")
        .toLowerCase()
        .includes("avigilonalta")
  );
}
